






import { Component, Vue, Prop } from 'vue-property-decorator'
import ChecklistsSideBar from '@/components/ChecklistsSideBar.vue'

@Component<BaseLayout>({
  components: {
    ChecklistsSideBar
  }
})
export default class BaseLayout extends Vue {}
